import React from 'react';
export const FileList = ({ files }) => {
  return (
    <div className="mt-8 p-6 bg-white rounded-xl shadow-lg border border-gray-200">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
        <span className="inline-block mr-3 text-purple-600">📊</span>
        Processing Summary
      </h2>
      {files.length === 0 ? (
        <p className="text-gray-500 text-center py-4">No files processed yet.</p>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-gray-200">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="py-3 px-6 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  File Name
                </th>
                <th className="py-3 px-6 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Status
                </th>
                <th className="py-3 px-6 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                  Transcript / Error
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {files.map(fileItem => (
                <tr key={fileItem.id} className="hover:bg-gray-50 transition-colors">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 truncate max-w-xs md:max-w-md">
                    {fileItem.file.name}
                  </td>
                  <td className="py-4 px-6 whitespace-nowrap">
                    <span className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full
                        ${fileItem.status === 'pending' ? 'bg-yellow-100 text-yellow-800' : ''}
                        ${fileItem.status === 'processing' ? 'bg-blue-100 text-blue-800 animate-pulse' : ''}
                        ${fileItem.status === 'completed' ? 'bg-green-100 text-green-800' : ''}
                        ${fileItem.status === 'failed' ? 'bg-red-100 text-red-800' : ''}
                      `}>
                      {fileItem.status}
                    </span>
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-700 max-w-prose break-words">
                    {fileItem.transcript && (
                      <p className="line-clamp-3 hover:line-clamp-none cursor-pointer">
                        {fileItem.transcript}
                      </p>
                    )}
                    {fileItem.error && (
                      <p className="text-red-500 font-medium">Error: {fileItem.error}</p>
                    )}
                    {!fileItem.transcript && !fileItem.error && fileItem.status !== 'processing' && (
                      <p className="text-gray-400 italic">No result yet or pending processing.</p>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}